import { render } from "./HomeNavigation.vue?vue&type=template&id=2ef73c4a&scoped=true"
import script from "./HomeNavigation.vue?vue&type=script&lang=js"
export * from "./HomeNavigation.vue?vue&type=script&lang=js"

import "./HomeNavigation.vue?vue&type=style&index=0&id=2ef73c4a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ef73c4a"]])

export default __exports__